














import { Prop, Component, Vue } from "vue-property-decorator";
import { PostClass } from "../../types";
import Post from "./Post/Post.vue";
import NewPost from "./NewPost.vue";

@Component({
  components: { NewPost, Post },
})
export default class NewsFeed extends Vue {
  @Prop() private posts!: PostClass[];

  deletePost(post_key_in_array: number) {
    this.posts.splice(post_key_in_array, 1);
  }
}
